import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

// The admin page and the guest page `/s/:token` live in src/features/sharing (pages/, guest/).

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="page">
      <h1>{t('errors.notFoundTitle')}</h1>
      <Link to="/">{t('shell.home')}</Link>
    </div>
  );
}
